export enum ErrorType {
  Error = 'error',
  Warning = 'warning',
}
